<ion-header [translucent]="true">
	<ion-toolbar>
		<ion-title
			><span class="highlight">{{ 'applePay.title' | translate }}</span
			><br
		/></ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<h1 class="ion-no-margin ion-text-bold ion-text-center" style="font-size: 4rem">
		{{ formattedTotalPrice }}
	</h1>
</ion-content>
<ion-footer class="ion-padding">
	<!-- Tip Display (read-only) -->
	@if (paySessionStatistics?.tipsValue) {
		<app-info-row>
			<div left>{{ 'common.tipLabel' | translate }}</div>
			<div right>{{ formattedTips }}</div>
		</app-info-row>
	}
	<hr class="divider" />
	<app-info-row>
		<div left>
			{{ 'statistics.total' | translate }} (<span>{{ paySessionStatistics?.selectedProductsCount }}</span> &nbsp;{{
				'statistics.items' | translate
			}})
		</div>
		<div right>{{ formattedTotalPrice }}</div>
	</app-info-row>
	@if (loading) {
		<ion-spinner></ion-spinner>
	}
	<ion-button (click)="confirmButton()" expand="block"> {{ 'common.pay' | translate }}</ion-button>
</ion-footer>
